import { render, staticRenderFns } from "./ticketDet.vue?vue&type=template&id=6cc7762a&"
import script from "./ticketDet.vue?vue&type=script&lang=js&"
export * from "./ticketDet.vue?vue&type=script&lang=js&"
import style0 from "./ticketDet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports